import { getLocale } from "../runtime";

const sv_rocountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Romania`
};

const rocountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_rocountryenglish(inputs)
	return "roCountryEnglish";
};

export { rocountryenglish as "roCountryEnglish" };